// extracted by mini-css-extract-plugin
export var closed = "_ad-1";
export var resizer = "_ad-0";